import * as React from 'react';

import cx from 'classnames';

import styles from './styles.scss';

type LineMode = 'gradient' | 'solid';

type DividerProps = {
  className?: string;
  labelClassName?: string;
  label?: string;
  lineMode?: LineMode;
};

const DEFAULT_ELEMENT_SIZE = { labelWidth: 0, labelHeight: 14, lineWidth: 0 };

export default function Divider({
  className,
  labelClassName,
  label,
  lineMode = 'solid',
}: DividerProps) {
  const labelClassname = React.useMemo(() => {
    return cx(styles.label, labelClassName);
  }, [labelClassName]);

  // get real width of the label by using element width
  const { labelWidth, lineWidth } = React.useMemo(() => {
    if (!label) return DEFAULT_ELEMENT_SIZE;
    try {
      const labelElement = document.createElement('span');
      labelElement.className = labelClassname;
      labelElement.style.visibility = 'hidden';
      labelElement.style.position = 'absolute';
      labelElement.style.top = '-9999px';
      labelElement.style.left = '-9999px';
      labelElement.textContent = label;
      document.body.appendChild(labelElement);
      const width = labelElement.offsetWidth;
      document.body.removeChild(labelElement);

      const labelWidth = Math.ceil(width + 4);
      const labelHeight = labelElement.offsetHeight;
      const lineWidth = `calc(50% - ${Math.ceil(labelWidth / 2)}px - 8px)`;

      return {
        labelWidth,
        labelHeight,
        lineWidth,
      };
    } catch {
      return DEFAULT_ELEMENT_SIZE;
    }
  }, [label, labelClassname]);

  const isGradientLineMode = lineMode === 'gradient';

  return (
    <div className={cx(styles.container, className)}>
      {label ? (
        <>
          <div
            className={cx(
              styles.line,
              isGradientLineMode && styles.gradient,
              styles.leftLine
            )}
            style={{ width: lineWidth }}
          />
          <span
            className={cx(
              labelClassname,
              isGradientLineMode && styles.labelInGradientMode
            )}
            style={{ width: labelWidth }}
          >
            {label}
          </span>
          <div
            className={cx(
              styles.line,
              isGradientLineMode && styles.gradient,
              styles.rightLine
            )}
            style={{ width: lineWidth }}
          />
        </>
      ) : (
        <div
          className={cx(
            styles.line,
            styles.fullWidthLine,
            isGradientLineMode && styles.gradienFullWidthLine
          )}
        />
      )}
    </div>
  );
}
